// Barre de progression « travaillée » (maquette validée le 2026-09-26) :
// repères à 25/50/75 %, remplissage bombé avec le pourcentage dedans, couleur
// qui monte avec l'avancement (rouge → ambre → vert), or à 100 %.
// Utilisée PARTOUT où une complétion s'affiche (barre latérale, accueil,
// bandeau d'un set, vignettes) pour que toutes les barres évoluent ensemble.
//   size : "sm" (barre latérale), "md" (vignettes et modules d'accueil),
//          "lg" (bandeau d'un set, progression globale).
//   showCount : affiche « possédées / total » à droite (sinon barre seule).
// Palier de couleur d'un pourcentage, réutilisé hors barre (ex. bordure
// d'accent des cartes « Progression des collections ») pour que tout ce qui
// affiche une complétion parle le même langage de couleur.
export const tierOf = (pct) => {
  const p = Math.max(0, Math.min(100, Math.round(pct || 0)));
  return p >= 100 ? "full" : p === 0 ? "dim" : p < 34 ? "lo" : p < 67 ? "mid" : "hi";
};

export const ProgressBar = ({ pct = 0, owned = 0, total = 0, size = "sm", showCount = true, className = "" }) => {
  const p = Math.max(0, Math.min(100, Math.round(pct || 0)));
  const level = tierOf(p);
  return (
    <span className={`pg pg-${size} pg-${level} ${className}`}>
      <span className="pgt">
        <span className="tk" /><span className="tk" /><span className="tk" />
        {p > 0 && <b style={{ width: `${p}%` }}><em>{p >= 100 ? "✓" : `${p}%`}</em></b>}
      </span>
      {showCount && (
        <span className="pgv">{p >= 100 ? `Complet · ${total}` : `${owned} / ${total}`}</span>
      )}
    </span>
  );
};
